import { memo } from 'react';
import styles from '@features/Unsubscribe/steps/EmailEnter/EmailEnter.module.scss';
type TpItemData = {
  title: string;
  id: number;
  link?: string;
};
export const Item = memo((props: {
  item: TpItemData;
}) => {
  const {
    item
  } = props;
  return <p className={styles.item}>
      <span className={styles.ordering}>{item.id}</span>
      <span>
        {item.title}
        <a href="mailto:support@mimika-app.com?subject=Cancelation failed: email not found" className={styles.link}>
          {item.link}
        </a>
      </span>
    </p>;
});
export const contentData: TpItemData[] = [{
  id: 1,
  title: 'Make sure your address is correct'
}, {
  id: 2,
  title: 'Use the address you used to sign up'
}, {
  id: 3,
  title: 'Try your other email address, if you have one (or a few)'
}, {
  id: 4,
  title: 'If you still having troubles, contact us via ',
  link: 'support@mimika-app.com'
}];
Item.displayName = 'Item';